import React from "react";
import {useAddress,MediaRenderer,useSDK} from "@thirdweb-dev/react";
import dp from "../images/ls1.png";
import { useState } from "react";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import { Link } from "react-router-dom";
import { TailSpin } from "react-loader-spinner";
import "./loginStyle.css";
import {lensClient} from "../client/LensClient";
import { ethers } from "ethers";

export default function Authentication(){
    const address = useAddress();
    const [auth,setAuth] = useState(false);
    const [profile, setProfile] = useState();

  const handleLogin = async () => {
    if (!address) {
      toast.info("Please Connect Your Wallet!!",{
        position:toast.POSITION.TOP_CENTER
      })
    };

    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();

    //const managedProfiles = await lensClient.wallet.profilesManaged({ for: address });
    const { id, text } = await lensClient.authentication.generateChallenge({
      signedBy: address,
      //for: YOUR_PROFILE_ID, // e.g "0x01"
    });
  
    const signature = await signer.signMessage(text); // text returned from authentication.generateChallenge
    await lensClient.authentication.authenticate({ id:id, signature:signature});
    setAuth(true);
    const accessTokenResult = await lensClient.authentication.getAccessToken();
    const accessToken = accessTokenResult.unwrap();
 
    const profiles = await lensClient.profile.fetchAll({
      where: {
        ownedBy: [address],
      },
    })

    setProfile(profiles.items);

    // v1 method for authentication, no longer in use

    //  // 1. Generate challenge which comes from the Lens API
    // const challenge = await generateChallenge(address);
    // if (!challenge) return;
    // // 2. Sign the challenge with the user's wallet
    // const signature = await sdk?.wallet.sign(challenge.data.challenge.text);
    //  // 3. Send the signed challenge to the Lens API
    // const accessTokens = await authenticate(address, signature);
    // await setAuthenticationToken({ token: accessTokens.data.authenticate });
    // console.log(accessTokens.data.authenticate);
    // setAuth(true);
  };



  // const {loading,error,data} = useQuery(GET_PROFILES_BY_ADDRESS,{
  //   variables:{
  //     request:{ownedBy:[address]},
  //   },
  // });

  if(auth===false){
    return(<button className="signInbtn" onClick={()=>handleLogin()}><p>Sign In With Lens</p></button>);
  }

  if(profile===null|| profile?.length==="0"){
    toast.info("You don't have any profile yet.",{
      position:toast.POSITION.TOP_CENTER
    })
    return(<button className="signInbtn"><p><Link to ='/create'>Create Your Profile</Link></p></button>);
  }

  return (
    <>
    {profile==null?<div className="spn">
                <TailSpin height={50}></TailSpin>
      </div>:
    <>
    {profile?.length===0?
    <button className="signInbtn"><p><Link to ='/create'>Create Your Profile</Link></p></button>:
    <div className="uprofile">
      {profile[0]?.metadata?.picture?.optimized?.uri!=null?
      <MediaRenderer
        src={profile[0]?.metadata?.picture?.optimized?.uri || ""}
        alt={profile[0]?.handle?.localName||""}
        style={{
          cursor:"pointer",
          width: 40,
          height: 40,
          borderRadius: "50%",
        }}
        />:
        <img
        src = {dp} 
        alt={profile[0]?.handle?.localName||""}
        style={{
          cursor:"pointer",
          width: 40,
          height: 40,
          borderRadius: "50%",
        }}
        />}
        <Link to = {`/myProfile/${profile[0].id}`}><p>Hello {profile[0]?.handle?.localName || profile[0]?.displayName} !!</p></Link>
      </div>
    }
    </>}
    <ToastContainer/>
    </>
  );
};